import { render, staticRenderFns } from "./modern-contemporary.vue?vue&type=template&id=144250e6"
import script from "./modern-contemporary.vue?vue&type=script&lang=js"
export * from "./modern-contemporary.vue?vue&type=script&lang=js"
import style0 from "./modern-contemporary.vue?vue&type=style&index=0&id=144250e6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports